<script setup>
import { ArrowUp } from 'lucide-vue-next';
import { onBeforeUnmount, onMounted, ref } from 'vue';

const scrollY = ref()

onMounted(() => {
    window.addEventListener('scroll', handleScroll);
})

onBeforeUnmount(()=>{
    window.removeEventListener('scroll', handleScroll);
})

const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
}

const handleScroll = () => {
    scrollY.value = window.scrollY
}
</script>

<template>
    <div class="fixed bottom-6 right-6 z-2" v-show="scrollY > 250">
        <button class="p-2 rounded-full bg-primary border shadow flex flex-col items-center" @click="scrollToTop">
            <ArrowUp />
        </button>
    </div>
</template>
